import { cloneDefaultFilters, cloneDefaultLayout } from "../constants/defaults";

const baseLayout = cloneDefaultLayout();

const mockViews = [
  {
    id: "view-machine",
    name: "Por máquina",
    isSystem: true,
    config: {
      filters: { ...cloneDefaultFilters() },
      groupBy: "machine",
      visibleColumns: [...baseLayout.visibleColumns],
    },
  },
  {
    id: "view-period",
    name: "Por período",
    isSystem: true,
    config: {
      filters: { ...cloneDefaultFilters() },
      groupBy: "period",
      visibleColumns: ["label", "period", "plan", "simulated", "realized", "attendancePct", "gap", "status"],
    },
  },
  {
    id: "view-bottleneck",
    name: "Por gargalo",
    isSystem: true,
    config: {
      filters: { ...cloneDefaultFilters(), onlyBottlenecks: true },
      groupBy: "bottleneck",
      visibleColumns: ["label", "plan", "simulated", "realized", "attendancePct", "gap", "status", "bottleneck"],
    },
  },
  {
    id: "view-risk",
    name: "Por risco",
    isSystem: true,
    config: {
      filters: { ...cloneDefaultFilters() },
      groupBy: "risk",
      visibleColumns: ["label", "riskLevel", "plan", "simulated", "realized", "attendancePct", "gap", "status", "bottleneck"],
    },
  },
];

export default mockViews;
